export default __webpack_public_path__ + "20597adb7636ba0f4a7139faa3eeb470.svg";